<template>
		<div :class="{'transition': item.is_play_live || item.is_play_preview}" :style="{ zIndex:item.layer_index, width: '100%', mixBlendMode: content && content.blendMode ? content.blendMode:'normal'}">
			<element-media
				:item="item"
				:status="status"
				v-show="!item.is_hidden"
				v-if="item.type === 'media' || item.type === 'image' || item.type === 'video' && (item.is_play_live || item.is_play_preview)"
			/>
			<element-zoom
				:item="item"
				:status="status"
				v-if="item.type === 'zoom_meeting' && (item.is_play_live || item.is_play_preview)"
			/>
			<element-custom-page
				:item="item"
				:status="status"
				v-show="!item.is_hidden"
				v-if="item.type === 'custom_page' && (item.is_play_live || item.is_play_preview)"
			/>
			<element-video-input
				:item="item"
				:status="status"
				v-show="!item.is_hidden"
				v-if="item.type === 'video_input' && (item.is_play_live || item.is_play_preview)"
			/>
			<element-composition
				:item="item"
				v-show="!item.is_hidden"
				v-if="item.type === 'composition' && (item.is_play_live || item.is_play_preview)"
			/>
			<element-ticker
				:item="item"
				:status="status"
				v-show="!item.is_hidden"
				v-if="item.type === 'ticker' && (item.is_play_live || item.is_play_preview)"
			/>
			<element-lottie
				:item="item"
				:status="status"
				v-show="!item.is_hidden"
				v-if="item.type === 'lottie' && (item.is_play_live || item.is_play_preview)"
			/>
			<element-lower-third
				:item="item"
				:status="status"
				v-show="!item.is_hidden"
				v-if="item.type === 'lower_third' && (item.is_play_live || item.is_play_preview)"
				:delay="delay"
			/>
			<element-timer
				:item="item"
				:status="status"
				v-show="!item.is_hidden"
				v-if="item.type === 'timer' && (item.is_play_live || item.is_play_preview)"
			/>
			<element-v-cam
				:item="item"
				:status="status"
				v-show="!item.is_hidden"
				v-if="item.type === 'virtual_cam'"
			/>
			<element-audio
				:item="item"
				:status="status"
				:delay="delay"
				v-show="!item.is_hidden"
				v-if="item.type === 'audio' && (item.is_play_live || item.is_play_preview)"
			/>
			<element-custom-command
				:item="item"
				:status="status"
				v-if="item.type === 'custom_command' && (item.is_play_live || item.is_play_preview)"
			/>
			<element-rtmp
				:item="item"
				:status="status"
				v-if="item.type === 'lightstream_rtmp'"
			/>
		</div>
</template>

<script>
import ElementMedia from '@/components/ElementMedia.vue';
import ElementZoom from '@/components/ElementZoom.vue';
import ElementCustomPage from '@/components/ElementCustomPage.vue';
import ElementVideoInput from '@/components/ElementVideoInput.vue';
import ElementComposition from '@/components/ElementComposition.vue';
import ElementTicker from '@/components/ElementTicker.vue';
import ElementLottie from '@/components/ElementLottiePlayer.vue';
import ElementLowerThird from '@/components/ElementLowerThird.vue';
import ElementTimer from '@/components/ElementTimer.vue';
import ElementVCam from '@/components/ElementVCam.vue';
import ElementAudio from '@/components/ElementAudio.vue';
import ElementCustomCommand from '@/components/ElementCustomCommand.vue';
import ElementRtmp from '@/components/ElementRtmp.vue';

export default {
	data() {
		return {
			// composition error
			videoOptions: [],
			programOptions: [],
		};
	},
	name: 'StreamElement',
	props: {
		item: {
			type: Object,
		},
		status: {
			type: String,
			default: 'live',
		},
		muted: {
			default: false,
		},
		delay: {},
	},
	components: {
		ElementMedia,
		ElementZoom,
		ElementCustomPage,
		ElementVideoInput,
		ElementComposition,
		ElementTicker,
		ElementLottie,
		ElementLowerThird,
		ElementTimer,
		ElementVCam,
		ElementAudio,
		ElementCustomCommand,
		ElementRtmp,
	},
	methods: {
	},
	computed: {
		content() {
			return this.item.content && this.item.content !== ''
				? JSON.parse(this.item.content) : {};
		},
	},
	watch: {
	},
};
</script>

<style lang="scss">
.transition {
	position: absolute;
	-webkit-animation-name: transition;
	-webkit-animation-duration: .5s;
	animation-name: transition;
	animation-duration: .5s;
	}

	@keyframes transition {
	from {
		opacity : 0;
	}
	to {
		opacity : 1;
	}
}
</style>
